<template lang="pug">
  .settings
    p На этой странице вы можете выбрать нужный вам раздел и настроить параметры своего аккаунта на нашем сервисе
    .settings__row
      .settings__account.settings__wayfinder.setting
        .setting__header
          h3
            font-awesome-icon.settings__wayfinder-icon(icon="smile")
            | Раздел «Данные аккаунта»
        .settings__wayfinder-content
          span Позволяет изменить:
          ul
            li Название вашей компании
            li Вашу фамилию и имя
            li Телефон и Email
            li Пароль к кабинету администратора
        router-link.settings__wayfinder-button.btn(:to="{name: 'account'}")
          | Перейти в раздел: Данные аккаунта
      .settings__payment.settings__wayfinder.setting
        .setting__header
          h3
            font-awesome-icon.settings__wayfinder-icon(icon="money-bill")
            | Раздел «Платежи и баланс»
        .settings__wayfinder-content
          span Позволяет:
          ul
            li Посмотреть текущий баланс вашего аккаунта
            li Посмотреть историю платежей и списаний за использование нашего сервиса
            li Пополнить баланс
            li Изменить тарифный план на использование нашего сервиса
        router-link.settings__wayfinder-button.btn(:to="{name: 'payments'}")
          | Перейти в раздел: Платежи и баланс
    hr.box__hr
    p.notice
      | Настройки, относящиеся к самому конструктору, вы можете сделать в соответствующих вкладках ваших конструкторов
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faSmile, faMoneyBill } from '@fortawesome/free-solid-svg-icons';

library.add(faSmile, faMoneyBill);

export default {
  components: {
    FontAwesomeIcon
  }
};
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/core.scss';

.settings {
  @at-root {
    #{&}__row {
      display: flex;
      // justify-content: space-between;
      flex-wrap: wrap;
      padding-bottom: 20px;
    }

    #{&}__wayfinder {
      max-width: 380px;
      display: flex;
      flex-direction: column;
      margin-right: 30px;

      &:last-of-type {
        margin-right: 0;
      }
    }

    #{&}__wayfinder-icon {
      color: _palette(base, primary);
      font-size: 0.8em;
      margin-right: 10px;
    }

    #{&}__wayfinder-content {
      flex-grow: 1;
    }

    #{&}__wayfinder-button {
      text-align: center;
    }
  }
  ul {
    list-style: none; /* Remove default bullets */
  }

  ul li::before {
    content: '\2022'; /* Add content: \2022 is the CSS Code/unicode for a bullet */
    color: #a13f00; /* Change the color */
    font-weight: bold; /* If you want it to be bold */
    display: inline-block; /* Needed to add space between the bullet and the text */
    width: 0.8em; /* Also needed for space (tweak if needed) */
    margin-left: -1em; /* Also needed for space (tweak if needed) */
  }
}
.setting {
  width: calc(50% - 30px);

  &:last-child {
    margin-right: 0;
  }

  &__header {
    h3 {
      padding-bottom: 8px;
      border-bottom: 1px solid #c69b71;
    }
  }
}

@media screen and (max-width: 768px) {
  .setting {
    width: 100%;
  }
}
</style>
